module.exports = __webpack_public_path__ + "static/media/trial3.13b6980d.mp3";